/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScreenDataFinalEvaluationMad model module.
 * @module model/ScreenDataFinalEvaluationMad
 * @version 1.0.0
 */
class ScreenDataFinalEvaluationMad {
    /**
     * Constructs a new <code>ScreenDataFinalEvaluationMad</code>.
     * @alias module:model/ScreenDataFinalEvaluationMad
     */
    constructor() { 
        
        ScreenDataFinalEvaluationMad.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScreenDataFinalEvaluationMad</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScreenDataFinalEvaluationMad} obj Optional instance to populate.
     * @return {module:model/ScreenDataFinalEvaluationMad} The populated <code>ScreenDataFinalEvaluationMad</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScreenDataFinalEvaluationMad();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('file_name')) {
                obj['file_name'] = ApiClient.convertToType(data['file_name'], 'String');
            }
            if (data.hasOwnProperty('error_msg')) {
                obj['error_msg'] = ApiClient.convertToType(data['error_msg'], 'String');
            }
            if (data.hasOwnProperty('download_url')) {
                obj['download_url'] = ApiClient.convertToType(data['download_url'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The id of the document
 * @member {Number} id
 */
ScreenDataFinalEvaluationMad.prototype['id'] = undefined;

/**
 * The name of the weekly document
 * @member {String} file_name
 */
ScreenDataFinalEvaluationMad.prototype['file_name'] = undefined;

/**
 * Error message to report
 * @member {String} error_msg
 */
ScreenDataFinalEvaluationMad.prototype['error_msg'] = undefined;

/**
 * The download link for the weekly document
 * @member {String} download_url
 */
ScreenDataFinalEvaluationMad.prototype['download_url'] = undefined;






export default ScreenDataFinalEvaluationMad;

